import { TRIGGER_VISIT_SMS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    wpString?: string;
}

export default (visitId: string, ph?: string): Promise<Response> =>
    fetchWithRefresh(TRIGGER_VISIT_SMS(visitId, ph), {
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('Error sending SMS');
        }
    });
